import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EarthLock, Siren } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { ConnectionsTable } from './ConnectionsTable';
import { ExternalConnectionType } from '@/lib/integrationTypes/externalConnectionTypes';
import { useListConnections } from '@/hooks/externalConnectionsApi';

const ExternalConnections: React.FC = () => {
  const navigate = useNavigate();

  const {
    data: connections,
    isLoading: connectionsLoading,
  } = useListConnections();

  return (
    <div className="mx-auto text-white">
      <ConnectionsTable
        connections={connections ?? []}
        isLoading={connectionsLoading}
        headerActions={
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button size="sm">
                Add Connection
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => navigate(`/connections/add-connection?connectionType=${ExternalConnectionType.Vms}`)}>
                <EarthLock className="mr-2 h-4 w-4 text-lime" />
                Add VMS
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => navigate(`/connections/add-connection?connectionType=${ExternalConnectionType.ExternalService}`)}>
                <Siren className="mr-2 h-4 w-4 text-lime" />
                Add External Service
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        }
      />
    </div>
  );
};

export default ExternalConnections;
